import * as S from "./styles";
import { prize, prizeType } from "../../../../utils/timer";
import { TournamentResponse } from "../../../../api/tournament";

interface TimerPrizeListProps {
  data: TournamentResponse | null;
  visibleRanks: number[];
  subPrizeFont: number;
}

const TimerPrizeList = ({
  data,
  visibleRanks,
  subPrizeFont,
}: TimerPrizeListProps) => {
  return (
    <S.TimerPrizeListWrapper>
      {data?.moneyInChip.map((item, index) =>
        index <= 2 ? (
          <S.TimerPrizeItemTop3
            isTop3={index < 3}
            style={{ marginTop: index === 3 ? "20px" : "" }}
            subPrizeFont={subPrizeFont}
          >
            <div className={`rank ${index < 3 && "high"}`}>{`${index + 1}${
              index === 0 ? "st" : index === 1 ? "nd" : "rd"
            }`}</div>
            <div className="prize-box">
              <div className={`prize ${index < 3 && "high"}`}>
                <span>{prize(data, item, index)}</span> {prizeType(item)}
              </div>
              {item.subPrize && (
                <div className="sub-prize">{item.subPrize}</div>
              )}
            </div>
          </S.TimerPrizeItemTop3>
        ) : visibleRanks.includes(index + 1) ? (
          <S.TimerPrizeItem
            length={data?.moneyInChip.length}
            key={index}
            style={{
              transition: "transform 1s ease-in-out, opacity 1s ease-in-out",
            }}
            subPrizeFont={subPrizeFont}
          >
            <div className="rank">{`${index + 1}`}th</div>
            <div className="prize-box">
              <div className="prize">
                <span>{prize(data, item, index)}</span> {prizeType(item)}
              </div>
              {item.subPrize && (
                <div className="sub-prize">{item.subPrize}</div>
              )}
            </div>
          </S.TimerPrizeItem>
        ) : null,
      )}
    </S.TimerPrizeListWrapper>
  );
};

export default TimerPrizeList;
